import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const TimesBold = createSvgIcon(
  () => (
    <path d="M31.25 23L43.75 10.5C45.375 9 45.375 6.5 43.75 5L41 2.25C39.5 0.625 37 0.625 35.5 2.25L23 14.75L10.375 2.25C8.875 0.625 6.375 0.625 4.875 2.25L2.125 5C0.5 6.5 0.5 9 2.125 10.5L14.625 23L2.125 35.625C0.5 37.125 0.5 39.625 2.125 41.125L4.875 43.875C6.375 45.5 8.875 45.5 10.375 43.875L23 31.375L35.5 43.875C37 45.5 39.5 45.5 41 43.875L43.75 41.125C45.375 39.625 45.375 37.125 43.75 35.625L31.25 23Z" fill="#6D7278"/>
  ),
  '0 0 46 46'
);
